import React from "react"
import { User } from "../../../../../../../../components/templates/chat/user"
import { Types } from "../../../../../../../../rpcs/dist/EpisodeRPC"
import { MessageEditor } from "./types/message"
import { IEditorContent } from "../../../../../../types"
import { IntroductionEditor } from "./types/introduction"
import { PickupEditor } from "./types/pickup"
import { AnnotationEditor } from "./types/annotation"
import { HeadlineEditor } from "./types/headline"
import { QuotationEditor } from "./types/quotation"
import { SurveyEditor } from "./types/survey"

interface IProps {
  content: IEditorContent
  prevContent: IEditorContent | null
}

export const Edit = (props: IProps) => (
  <React.Fragment key={props.content.uuid}>
    <User content={props.content} prevContent={props.prevContent} />
    {(() => {
      switch (props.content.type) {
        case Types.Message:
          return <MessageEditor content={props.content} />
        case Types.Annotation:
          return <AnnotationEditor content={props.content} />
        case Types.Introduction:
          return <IntroductionEditor content={props.content} />
        case Types.Pickup:
          return <PickupEditor content={props.content} />
        case Types.Headline:
          return <HeadlineEditor content={props.content} />
        case Types.Quotation:
          return <QuotationEditor content={props.content} />
        case Types.Survey:
          return <SurveyEditor content={props.content} />
        default:
          return null
      }
    })()}
  </React.Fragment>
)
